export enum CurrencySelectorThemes {
  CURRENCY = 'currency',
  CURRENCY_DARK = 'currency-dark',
}
